import { BreadcrumbItem } from '@components/display/breadcrumbs';
import { createContext, ReactNode, useContext } from 'react';

type OnlineTrainingContextType = {
    setBreadcrumbs: React.Dispatch<React.SetStateAction<BreadcrumbItem[]>>;
    setExtraButton: React.Dispatch<React.SetStateAction<ReactNode>>;
};

const OnlineTrainingContext = createContext<OnlineTrainingContextType | undefined>(undefined);

const useOnlineTrainingContext = () => {
    const context = useContext(OnlineTrainingContext);
    if (!context) throw new Error('useOnlineTrainingContext must be used within a provider');
    return context;
};

export { OnlineTrainingContext, useOnlineTrainingContext };
export type { OnlineTrainingContextType };
